(function () {
  "use strict";

  // Sistema PubSub simples
  var PubSub = {
    events: {},
    subscribe: function (event, callback) {
      if (!this.events[event]) {
        this.events[event] = [];
      }
      this.events[event].push(callback);
      
      // Retornar função para unsubscribe
      var self = this;
      return function () {
        if (self.events[event]) {
          var index = self.events[event].indexOf(callback);
          if (index > -1) {
            self.events[event].splice(index, 1);
          }
        }
      };
    },
    publish: function (event, data) {
      if (this.events[event]) {
        this.events[event].forEach(function (callback) {
          callback(data);
        });
      }
    },
    unsubscribe: function (event, callback) {
      if (this.events[event]) {
        var index = this.events[event].indexOf(callback);
        if (index > -1) {
          this.events[event].splice(index, 1);
        }
      }
    }
  };

  // Eventos de Facets
  var FACETS_EVENTS = {
    change: "facets:change",
    updated: "facets:updated",
    loading: "facets:loading"
  };

  // Classe FacetField como Web Component
  class FacetField extends HTMLElement {
    constructor() {
      super();
      this.facet = null;
      this.updateUIUnsubscriber = function () {};
      this.loadingUnsubscriber = function () {};
      this.facetsInputs = this.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      
      // Subscribir aos eventos
      var self = this;
      this.updateUIUnsubscriber = PubSub.subscribe(FACETS_EVENTS.updated, function (data) {
        self.handleUpdateFromDoc(data);
      });

      // Adicionar listeners de loading nos inputs
      this.facetsInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          self.handleLoading();
        });
      });
    }

    handleLoading() {
      this.classList.add('loading');
    }

    disconnectedCallback() {
      if (this.updateUIUnsubscriber) {
        this.updateUIUnsubscriber();
      }
      if (this.loadingUnsubscriber) {
        this.loadingUnsubscriber();
      }
    }

    connectedCallback() {
      this.initFacetProps();
      this.initEventListeners();
    }

    initFacetProps() {
      var name = this.getAttribute('name');

      if (!name) {
        throw new Error(this.tagName + ' requires name attribute');
      }

      this.facet = { name: name, unique: false, value: '' };
    }

    initEventListeners() {
      var radios = this.querySelectorAll('input[type="radio"]');
      var checkboxes = this.querySelectorAll('input[type="checkbox"]');
      var select = this.querySelector('select');
      var self = this;

      if (!radios.length && !checkboxes.length && !select) {
        throw new Error(this.tagName + ' requires radio, checkbox or select inputs');
      }

      if ((radios.length || select) && this.facet) {
        this.facet = Object.assign({}, this.facet, { unique: true });
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          self.handleChange(e);
        });
      });

      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function (e) {
          self.handleChange(e);
        });
      });

      if (select) {
        // Se for sort_by, desabilitar o listener do theme.js que causa refresh
        if (this.facet && this.facet.name === 'sort_by') {
          // Remover listener do theme.js se existir
          var themeNamespace = '.collectionSort';
          if (select.off) {
            select.off('change' + themeNamespace);
          }
          
          // Também remover listener nativo se foi anexado de outra forma
          // Criar um proxy para interceptar e prevenir
          var originalDispatchEvent = select.dispatchEvent;
          select.dispatchEvent = function(event) {
            if (event.type === 'change' && self.facet && self.facet.name === 'sort_by') {
              // Permitir apenas se não for do theme.js
              return originalDispatchEvent.call(this, event);
            }
            return originalDispatchEvent.call(this, event);
          };
        }
        
        // Atualizar classe has-value inicialmente
        self.updateSelectState(select);
        
        // Adicionar listener com prioridade máxima (capture phase + immediate)
        select.addEventListener('change', function (e) {
          // Prevenir que o listener do theme.js cause refresh completo da página
          if (self.facet && self.facet.name === 'sort_by') {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
          }
          
          self.handleChange(e);
          self.updateSelectState(select);
        }, true); // Usar capture phase para executar antes do theme.js
        
        // Adicionar listener de loading também no select
        select.addEventListener('change', function (e) {
          if (self.facet && self.facet.name === 'sort_by') {
            e.stopImmediatePropagation();
            e.stopPropagation();
          }
          self.handleLoading();
        }, true);
      }
    }

    getAddValue(target) {
      if (!this.facet) return;

      if (target.tagName === 'SELECT' || target.type === 'radio') {
        return true;
      }
      return target.checked;
    }

    updateSelectState(select) {
      if (!select) return;
      
      if (select.value && select.value !== '') {
        select.classList.add('has-value');
      } else {
        select.classList.remove('has-value');
      }
    }

    handleChange(event) {
      if (!this.facet) return;

      var target = event.target;
      var isBoolean = target.getAttribute('data-boolean');
      var newValue = target.value;
      var add = this.getAddValue(target);

      this.facet = Object.assign({}, this.facet, {
        unique: isBoolean ? true : this.facet.unique,
        value: isBoolean ? String(+(target.checked ? 1 : 0)) : newValue,
        add: isBoolean ? true : add
      });

      // Publicar evento de mudança
      PubSub.publish(FACETS_EVENTS.change, {
        facet: Object.assign({}, this.facet)
      });

      // Se for um select de sort_by, aplicar a ordenação
      if (this.facet.name === 'sort_by' && target.tagName === 'SELECT') {
        this.handleSortChange(target);
      }
    }

    handleSortChange(selectElement) {
      var self = this;
      
      // Prevenir que o theme.js intercepte e cause refresh
      // Remover o listener do theme.js permanentemente para este select
      var themeNamespace = '.collectionSort';
      if (selectElement && selectElement.off) {
        selectElement.off('change' + themeNamespace);
      }
      
      // Também tentar remover via jQuery se disponível
      if (window.jQuery && selectElement) {
        try {
          window.jQuery(selectElement).off('change' + themeNamespace);
        } catch(e) {}
      }
      
      // Adicionar classe loading
      this.classList.add('loading');

      // Obter todos os filtros ativos do formulário de filtros
      var filterForm = document.querySelector('#CollectionDynamicFiltersForm');
      var formData = new FormData();

      // Adicionar sort_by
      if (selectElement.value) {
        formData.append('sort_by', selectElement.value);
      }

      // Adicionar filtros ativos se existir o formulário de filtros
      if (filterForm && window.collectionDynamicFilters && typeof window.collectionDynamicFilters.getFormData === 'function') {
        try {
          var filterFormData = window.collectionDynamicFilters.getFormData();
          for (var pair of filterFormData.entries()) {
            formData.append(pair[0], pair[1]);
          }
        } catch (e) {
          console.warn('Erro ao obter dados do formulário de filtros:', e);
        }
      } else {
        // Se não houver filtros dinâmicos, usar os parâmetros da URL atual
        try {
          var currentUrl = new URL(window.location.href);
          var currentParams = new URLSearchParams(currentUrl.search);
          
          for (var param of currentParams.entries()) {
            if (param[0] !== 'sort_by' && param[0].startsWith('filter.')) {
              formData.append(param[0], param[1]);
            }
          }
        } catch (e) {
          console.warn('Erro ao obter parâmetros da URL:', e);
        }
      }

      // Aplicar a ordenação usando o sistema de filtros existente
      if (window.collectionDynamicFilters && typeof window.collectionDynamicFilters.renderCollectionPage === 'function') {
        // Usar o sistema de renderização AJAX existente
        // Passar false para shouldScroll para evitar scroll ao topo quando apenas sort_by muda
        window.collectionDynamicFilters.renderCollectionPage(formData, false);
        
        // Atualizar URL sem refresh
        var searchParams = new URLSearchParams(formData);
        var newUrl = window.location.pathname;
        if (searchParams.toString()) {
          newUrl += '?' + searchParams.toString();
        }
        window.history.replaceState({}, '', newUrl);
        
        // Remover classe loading quando a renderização terminar
        var removeLoading = function() {
          self.classList.remove('loading');
          document.removeEventListener('collection:filtered', removeLoading);
          
          // Re-habilitar o listener do theme.js após a atualização (se necessário)
          // Mas não vamos re-habilitar para evitar conflitos futuros
        };
        document.addEventListener('collection:filtered', removeLoading);
        
        // Timeout de segurança para remover loading
        setTimeout(function() {
          self.classList.remove('loading');
        }, 5000);
      } else {
        // Fallback: submeter o formulário normalmente
        var searchParams = new URLSearchParams(formData);
        var newUrl = window.location.pathname;
        if (searchParams.toString()) {
          newUrl += '?' + searchParams.toString();
        }
        window.location.href = newUrl;
      }
    }

    handleUpdateFromDoc(data) {
      var document = data.document;
      var id = this.getAttribute('id');

      if (!id) {
        throw new Error(this.tagName + ' requires id attribute');
      }

      var updatedUI = document.getElementById(id);

      if (updatedUI) {
        // Preservar o estado do select antes de substituir
        var currentSelect = this.querySelector('select');
        var currentValue = currentSelect ? currentSelect.value : null;
        var currentClasses = currentSelect ? currentSelect.className : null;
        var currentDataAttr = currentSelect ? currentSelect.dataset.facetFieldInitialized : null;

        // Se for apenas um select de sort_by, evitar substituição completa para não piscar
        if (this.facet && this.facet.name === 'sort_by' && currentSelect && updatedUI.querySelector('select')) {
          var newSelect = updatedUI.querySelector('select');
          var newOptions = newSelect.querySelectorAll('option');
          
          // Verificar se a opção atual ainda existe no novo select
          var optionExists = false;
          for (var i = 0; i < newOptions.length; i++) {
            if (newOptions[i].value === currentValue) {
              optionExists = true;
              break;
            }
          }
          
          if (optionExists && currentValue) {
            // Para sort_by, não precisamos substituir o elemento se o valor ainda é válido
            // Apenas atualizar as opções se necessário, mas manter o elemento atual
            // Isso evita o "piscar" visual
            
            // Verificar se as opções mudaram
            var form = this.querySelector('form');
            var newForm = updatedUI.querySelector('form');
            
            if (form && newForm) {
              var currentOptions = currentSelect.querySelectorAll('option');
              var optionsChanged = currentOptions.length !== newOptions.length;
              
              // Se as opções não mudaram, não fazer nada (evitar re-renderização)
              if (!optionsChanged) {
                // Apenas garantir que o valor está correto
                if (currentSelect.value !== currentValue) {
                  currentSelect.value = currentValue;
                  this.updateSelectState(currentSelect);
                }
                return; // Não substituir, evitar piscar
              }
              
              // Se as opções mudaram, atualizar apenas o select, não o elemento inteiro
              // Preservar o estado visual atual
              var wasFocused = document.activeElement === currentSelect;
              var scrollPosition = currentSelect.scrollTop;
              
              // Atualizar apenas o select, não o form inteiro
              currentSelect.innerHTML = newSelect.innerHTML;
              currentSelect.value = currentValue;
              
              // Restaurar classes e atributos
              if (currentClasses) {
                currentSelect.className = currentClasses;
              }
              if (currentDataAttr) {
                currentSelect.dataset.facetFieldInitialized = currentDataAttr;
              }
              
              this.updateSelectState(currentSelect);
              
              // Restaurar scroll e foco
              currentSelect.scrollTop = scrollPosition;
              if (wasFocused) {
                setTimeout(function() {
                  currentSelect.focus();
                }, 0);
              }
              
              // Não substituir o elemento, apenas atualizar conteúdo
              return;
            }
          }
        }

        // Fallback: substituir o elemento normalmente (para outros tipos de facet ou quando necessário)
        // Preservar classes e estado visual do elemento pai para evitar "piscar"
        var currentParentClasses = this.className;

        // Substituir o elemento
        this.parentNode.replaceChild(updatedUI, this);

        // Restaurar o valor e estado do select se existir
        var newSelect = updatedUI.querySelector('select');
        if (currentValue && newSelect) {
          newSelect.value = currentValue;
          
          // Restaurar classes do select
          if (currentClasses) {
            newSelect.className = currentClasses;
          }
          
          // Restaurar data attribute
          if (currentDataAttr) {
            newSelect.dataset.facetFieldInitialized = currentDataAttr;
          }
          
          // Atualizar estado visual do select se o método existir
          if (updatedUI.updateSelectState && typeof updatedUI.updateSelectState === 'function') {
            updatedUI.updateSelectState(newSelect);
          }
          
          // Prevenir que o theme.js re-anexe o listener após substituição
          if (this.facet && this.facet.name === 'sort_by') {
            var themeNamespace = '.collectionSort';
            if (newSelect.off) {
              newSelect.off('change' + themeNamespace);
            }
            if (window.jQuery) {
              try {
                window.jQuery(newSelect).off('change' + themeNamespace);
              } catch(e) {}
            }
          }
        }

        // Re-registrar o componente se necessário
        if (updatedUI.tagName.toLowerCase() === 'facet-field') {
          // O elemento já será um FacetField se o custom element foi definido
          // Garantir que os listeners do theme.js não sejam re-anexados
          if (updatedUI.facet && updatedUI.facet.name === 'sort_by') {
            setTimeout(function() {
              var select = updatedUI.querySelector('select');
              if (select) {
                var themeNamespace = '.collectionSort';
                if (select.off) {
                  select.off('change' + themeNamespace);
                }
                if (window.jQuery) {
                  try {
                    window.jQuery(select).off('change' + themeNamespace);
                  } catch(e) {}
                }
              }
            }, 50);
          }
        }
      }
    }
  }

  // Registrar o custom element
  if (typeof customElements !== 'undefined') {
    customElements.define('facet-field', FacetField);
  }

  // Expor PubSub e FACETS_EVENTS globalmente para uso em outros scripts
  window.PubSub = PubSub;
  window.FACETS_EVENTS = FACETS_EVENTS;

  // Inicializar componentes existentes na página
  function initFacetFields() {
    // Os custom elements são inicializados automaticamente quando definidos
    // Esta função pode ser usada para lógica adicional se necessário
    var facetFields = document.querySelectorAll('facet-field');
    if (facetFields.length > 0) {
      // Garantir que os selects dentro dos facet-fields tenham os listeners corretos
      facetFields.forEach(function(field) {
        var select = field.querySelector('select');
        if (select && !select.dataset.facetFieldInitialized) {
          select.dataset.facetFieldInitialized = 'true';
        }
      });
    }
  }

  // Inicializar quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetFields);
  } else {
    initFacetFields();
  }

  // Re-inicializar após atualizações AJAX
  document.addEventListener('collection:filtered', function () {
    setTimeout(function() {
      initFacetFields();
      
      // Prevenir que o theme.js re-anexe listeners de sort após AJAX
      var sortSelects = document.querySelectorAll('#SortBy, facet-field[name="sort_by"] select');
      sortSelects.forEach(function(select) {
        var themeNamespace = '.collectionSort';
        if (select.off) {
          select.off('change' + themeNamespace);
        }
        if (window.jQuery) {
          try {
            window.jQuery(select).off('change' + themeNamespace);
          } catch(e) {}
        }
      });
    }, 100);
  });

  // Re-inicializar após carregamento de seção Shopify
  document.addEventListener('shopify:section:load', function (event) {
    setTimeout(function() {
      initFacetFields();
      
      // Prevenir que o theme.js re-anexe listeners de sort após carregamento de seção
      var sortSelects = document.querySelectorAll('#SortBy, facet-field[name="sort_by"] select');
      sortSelects.forEach(function(select) {
        var themeNamespace = '.collectionSort';
        if (select.off) {
          select.off('change' + themeNamespace);
        }
        if (window.jQuery) {
          try {
            window.jQuery(select).off('change' + themeNamespace);
          } catch(e) {}
        }
      });
    }, 100);
  });
})();
